import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user/user.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import {User} from '../../services/user/user';
import {UploadComponent} from "../upload/upload.component";
@Component({
    selector: 'app-iff-upload',
    templateUrl: './iff-upload.component.html',
    styleUrls: ['./iff-upload.component.css'],
    imports: [UploadComponent]
})
export class IffUploadComponent implements OnInit {
  currentUrl: any;
  currentUser: User;
  userRole: any = null;
  businessType: any = null;
  constructor(private userService: UserService) {

  }

  ngOnInit() {
    this.currentUrl = location.pathname;
    // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
    this.userService.getUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        this.userRole = currentUser.roles[0].id;
        this.businessType = 'iff'+currentUser.permissions;
      }
    }, (error) => {
     // this.alertService.info('unable to get current user details');
    });
  }

}
